/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { DateTime } from 'luxon'
import { useMemo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Badge, BadgeProps } from '@mantine/core'

export type MandateStatusBadgeProps = BadgeProps & {
  mandate: Mandate
}

function MandateStatusBadge (props: MandateStatusBadgeProps) {
  const { mandate, ...others } = props

  const start = useMemo(
    () => DateTime.fromISO(mandate.startDate).toMillis(),
    [mandate.startDate]
  )
  const end = useMemo(
    () => DateTime.fromISO(mandate.endDate).toMillis(),
    [mandate.endDate]
  )

  const today = useMemo(() => new Date(), [])
  const hasEnded = useMemo(() => end <= today.getTime(), [end, today])
  const hasStarted = useMemo(() => start <= today.getTime(), [start, today])

  if (hasEnded) {
    return (
      <Badge {...others} color="gray">
        <FormattedMessage
          id="finished"
          defaultMessage="Terminé"
        />
      </Badge>
    )
  }
  if (hasStarted) {
    return (
      <Badge {...others} color="green">
        <FormattedMessage
          id="ongoing"
          defaultMessage="En cours"
        />
      </Badge>
    )
  }
  return (
    <Badge {...others} color="blue">
      <FormattedMessage
        id="to_come_up"
        defaultMessage="À venir"
      />
    </Badge>
  )
}

export default MandateStatusBadge
